import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { BusinessRole } from 'src/constants/user';
import {
  EmployerCompanyInformationPage,
  EmployerDetailBillingPageCVStaff,
  EmployerDisclaimersPage,
  EmployerSettingsPageCVStaff,
  EmployerStaffPageCVandPEOStaff,
  EmployersEmployeePage,
  EmployersPage,
} from 'src/pages/employers';
import { RouteProps } from 'src/types/router';

import { EmployersDetailOutlet } from './components';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <EmployersPage />,
    accessRoles: [
      ReactRouteAccessKey.hasPlatformRoles,
      ReactRouteAccessKey.hasPeoRoles,
      BusinessRole.PeoPayrollProviderUser,
    ],
  },
  {
    path: appRoutes.employers.detail.index,
    element: <EmployersDetailOutlet />,
    childRoutes: [
      {
        path: appRoutes.employers.detail.companyInformation,
        element: <EmployerCompanyInformationPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.employers.detail.disclaimers,
        element: <EmployerDisclaimersPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.employers.detail.wallet,
        element: <EmployerDetailBillingPageCVStaff />,
        accessRoles: [ReactRouteAccessKey.hasPlatformRoles],
      },
      {
        path: appRoutes.employers.detail.staff,
        element: <EmployerStaffPageCVandPEOStaff />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.employers.detail.employees,
        element: <EmployersEmployeePage />,
        accessRoles: [ReactRouteAccessKey.inherit, ReactRouteAccessKey.isNotPartnershipCompanyUser],
      },
      {
        path: appRoutes.employers.detail.settings,
        element: <EmployerSettingsPageCVStaff />,
        accessRoles: [ReactRouteAccessKey.hasPlatformRoles],
      },
    ],
    accessRoles: [
      ReactRouteAccessKey.hasPlatformRoles,
      ReactRouteAccessKey.hasPeoRoles,
      BusinessRole.PeoPayrollProviderUser,
    ],
  },
];

export const EMPLOYERS_ROUTE: RouteProps = {
  path: appRoutes.employers.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [
    ReactRouteAccessKey.hasPlatformRoles,
    ReactRouteAccessKey.hasPeoRoles,
    BusinessRole.PeoPayrollProviderUser,
  ],
};
